import React, {Fragment} from 'react';
//import {Link} from 'react-router-dom';
import Icon from '../../Icon';
import moment from "moment";
import classNames from "classnames";
import createLink from "../../../../libs/createLink";
import _ from "lodash";
import {isNoFollowProfil} from "../../../../libs/helper";

// let listType = {
//     like: {
//         icon: "heart-c",
//         text: "a aimé"
//     },
//     comment: {
//         icon: "comment-c",
//         text: "a commenté "
//     },
//     photo: {
//         icon: "picture-c",
//         text: "à ajouté une photo "
//     },
//     video: {
//         icon: "film-reel",
//         text: "à ajouté une vidéo "
//     },
//     friend: {
//         icon: "add-user-c",
//         text: "vous a ajouté à sa liste d'amis "
//     },
//     article: {
//         icon: "article-c",
//         text: "à ajouté un article "
//     },
//     'status': {
//         icon: "timeline-status",
//         text: "à ajouté un statut "
//     },
//     'topic': {
//         icon: "forum-c",
//         text: "à ajouté un topic "
//     }
// };

const NotificationItemUserLink = ({user}) => {
    if(user){
        let relLinkProfil = isNoFollowProfil(user) ? { rel: "nofollow" } : {};
        return <a href={createLink("userProfile", user)} {...relLinkProfil}>{_.capitalize(user.username)}</a>
    }
    return <div>compte supprimé</div>;
};

const NotificationItemSenders = ({mainSender, senders, cutLimit = 4}) => {
    if (senders.length <= 1) return <NotificationItemUserLink user={mainSender}/>;
    else if (senders.length <= cutLimit) {
        return (
            <Fragment>
                {senders.reverse().map((sender, i) => {
                    let separator = i === (senders.length - 2) ? ' et ' : (i === (senders.length - 1) ? ' ' : ', ');
                    return (
                        <Fragment>
                            <NotificationItemUserLink user={sender}/>{separator}
                        </Fragment>
                    )
                })}
            </Fragment>
        )
    } else if (senders.length > cutLimit) {
        let slicedSenders = senders.slice(0, cutLimit);
        let senderRestCount = senders.length - cutLimit;
        let isPlural = (senderRestCount === 1 ? '' : 's')
        return (
            <Fragment>
                {slicedSenders.map((sender, i) => {
                    let separator = (i === (slicedSenders.length - 1) ? ' ' : ', ');
                    return (
                        <Fragment>
                            <NotificationItemUserLink user={sender}/>{separator}
                        </Fragment>
                    )
                })}
                et {senderRestCount} autre{isPlural} personne{isPlural}
            </Fragment>
        )
    } else return null;
}

const likeMap = {
    'gallery': {
        text: 'photo',
        getLink: (notification) => createLink('mediaviewerPhoto', {
            media: {
                _id: notification.refId,
                slug: notification.refSlug
            }
        })
    },
    'video': {
        text: 'vidéo',
        getLink: (notification) => createLink('mediaviewerVideo', {
            media: {
                _id: notification.refId,
                slug: notification.refSlug
            }
        })
    },
    'article': {
        text: 'article',
        getLink: (notification) => createLink('article', {
            slug: _.get(notification,"owner.slug") || "",
            article: {
                _id: notification.refId,
                slug: notification.refSlug
            }
        })
    },
    'status': {
        text: 'statut',
        getLink: (notification) => notification.owner ? createLink('userProfile', notification.owner) : null
    }
}

const commentMap = {
    'gallery': {
        text: 'photo',
        getLink: (notification) => createLink('mediaviewerPhoto', {
            media: {
                _id: notification.refId,
                slug: notification.refSlug
            }
        })
    },
    'video': {
        text: 'vidéo',
        getLink: (notification) => createLink('mediaviewerVideo', {
            media: {
                _id: notification.refId,
                slug: notification.refSlug
            }
        })
    },
    'article': {
        text: 'article',
        getLink: (notification) => createLink('article', {
            slug: notification.owner.slug,
            article: {
                _id: notification.refId,
                slug: notification.refSlug
            }
        })
    },
    'status': {
        text: 'status',
        getLink: (notification) => notification.refIds ? createLink('userNotificationOne', {...notification.owner, notification : {_id : notification._id}}) : createLink('userProfile', notification.owner)
    }
}

const renderers = {
    'LIKE': {
        icon: "heart-c",
        content: ({notification, isPlural, isFemale}) => {
            let like = likeMap[notification.refKind];
            return <Fragment>
                <NotificationItemSenders mainSender={notification.sender} senders={notification.fSenders}/>
                {isPlural ? ' ont' : ' a'} aimé votre {like.text} {!!notification.refTitle &&
                <b>{notification.refTitle}</b>}.
            </Fragment>
        },
        getLink: (notification) => likeMap[notification.refKind].getLink(notification)
    },
    'STATUS': {
        icon: "timeline-status",
        content: ({notification, isPlural, isFemale}) => {
            return <Fragment>
                <NotificationItemSenders mainSender={notification.sender} senders={notification.fSenders}/>
                {isPlural ? ' ont' : ' a'} publié un message sur votre mur.
            </Fragment>
        },
        getLink: (notification) => notification.refIds ? createLink('userNotificationOne', {...notification.owner, notification : {_id : notification._id}}) : createLink('userProfile', notification.owner)
    },
    'COMMENT': {
        icon: "forum-c",
        content: ({notification, isPlural, isFemale}) => {
            let like = likeMap[notification.refKind];
            return <Fragment>
                <NotificationItemSenders mainSender={notification.sender} senders={notification.fSenders}/>
                {isPlural ? ' ont' : ' a'} commenté votre {like.text} {!!notification.refTitle &&
                <b>{notification.refTitle}</b>}.
            </Fragment>
        },
        getLink: (notification) => commentMap[notification.refKind] ? commentMap[notification.refKind].getLink(notification) : ()=>""
    },
    'COMMENT_CITATION': {
        icon: "forum-c",
        content: ({notification, isPlural, isFemale}) => {
            return <Fragment>
                <NotificationItemSenders mainSender={notification.sender} senders={notification.fSenders}/>
                {isPlural ? ' ont' : ' a'} cité votre nom dans un commentaire sur {!!notification.refTitle &&
                <b>{notification.refTitle}</b>}.
            </Fragment>
        },
        getLink: (notification) => commentMap[notification.refKind] ? commentMap[notification.refKind].getLink(notification) : ()=>""
    },
    'TOPIC_COMMENT': {
        icon: "comment-c",
        content: ({notification, isPlural, isFemale}) => {
            return <Fragment>
                <NotificationItemSenders mainSender={notification.sender} senders={notification.fSenders}/>
                {isPlural ? ' ont' : ' a'} répondu au sujet {!!notification.refTitle &&
                <b>{notification.refTitle}</b>}.
            </Fragment>
        },
        getLink: (notification) => createLink('forumTopic', {
            categoryParent: notification.data.forumMain,
            category: notification.data.forumParent,
            topic: {
                _id: notification.refId,
                slug: notification.refSlug,
            }
        })
    },
    'FRIEND_REQUEST': {
        icon: "add-user-c",
        content: ({notification, isPlural, isFemale}) => {
            return <Fragment>
                <NotificationItemUserLink user={notification.sender}/> veut vous ajouter à sa liste d'amis.
            </Fragment>
        },
        getLink: (notification) => createLink('userFriends', notification.owner)
    },
    'FRIEND_REQUEST_ACCEPTED': {
        icon: "add-user-c",
        content: ({notification, isPlural, isFemale}) => {
            return <Fragment>
                <NotificationItemUserLink user={notification.sender}/> a accepté votre demande d'amitié.
            </Fragment>
        },
        getLink: (notification) => createLink('userProfile', notification.sender)
    },
}

const Notification = ({data, onOpen}) => {
    let renderer = renderers[data.type];

    let isPlural = (Array.isArray(data.fSenders) && data.fSenders.length > 1);
    let gender = _.get(data,"sender.profile.gender") || 0;

    return renderer ? (
        <a
            href={renderer.getLink(data)}
            className={classNames("notification-item", {unread: !data.open})}
            onClick={() => onOpen()}>
            <div className="content">
                {renderer.content({
                    notification: data,
                    isPlural,
                    isFemale: ([2, 4, 6].includes(gender) && !isPlural)
                })}
            </div>
            <div className="sub">
                <Icon type={renderer.icon}/>
                <span className="date">
                    {moment(data.fUpdatedAt).fromNow()}
                </span>
            </div>
        </a>
    ) : null;
};

export default Notification;
